<template>
    <a-modal
        centered
        title="提示"
        :visible="visible"
        @cancel="cancel"
    >
        <slot name="context"></slot>
        <template slot="footer">
            <a-button type="primary" @click="cancel">确定</a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    name: "common-tips.component",
    data() {
        return {
            visible: false
        }
    },
    methods: {
        open() {
            this.visible = true;
        },
        cancel() {
            this.visible = false;
        },
    }
}
</script>

<style lang="scss">

</style>
